export var getSectionExtensionContents = function getSectionExtensionContents(_ref) {
  var header = _ref.header,
    subHeader = _ref.subHeader;
  return [{
    type: 'extensionFrame',
    content: [{
      type: 'heading',
      attrs: {
        level: 1,
        localId: null
      },
      content: [{
        type: 'text',
        text: "".concat(header)
      }]
    }, {
      type: 'paragraph',
      attrs: {
        localId: null
      },
      content: [{
        type: 'text',
        text: "".concat(subHeader)
      }]
    }, {
      type: 'paragraph',
      attrs: {
        localId: null
      }
    }]
  }];
};